"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeCalcExistingSpanLegacyProvider = exports.IkeCalcExistingSpanProvider = void 0;
const core_api_1 = require("@ikegps/core-api");
const transformSpanType = {
    spanType: {
        type: core_api_1.IkeFieldType.SELECT_LIST,
        transform: 'replace',
        replace: {
            NEXT_POLE: 'PREVIOUS_POLE',
            OTHER_POLE: 'OTHER_POLE'
        }
    }
};
const transformSpanLength = {
    spanLength: {
        type: core_api_1.IkeFieldType.VECTOR,
        transform: 'invert'
    }
};
const transformWireSag = {
    wireSag: {
        type: core_api_1.IkeFieldType.NUMBER,
        transform: 'invert'
    }
};
// Only include 'circuitMidSpanHeight'
const transformIkeCalcHeights = {
    wireAttachmentHeight: {
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude'
    },
    spanGuyAttachmentHeight: {
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude'
    },
    spanGuyMidSpanHeight: {
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude'
    },
    spanGuyHeightAtWEP: {
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude'
    }
};
// Only include midspan heights
// "PoleForeman - Mountain Ltd v10.3" / revision:hLzYAZXakA
const transformPoleForemanHeights = {
    spanCircuitHeight: {
        // Span / Power / Primary Circuit / Phase A Bolt Height
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude'
    },
    height_7qiq4lCO4X: {
        // Span / Power / Primary Circuit / Phase B Bolt Height
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude'
    },
    height_H2o4IVeOfQ: {
        // Span / Power / Primary Circuit / Phase C Bolt Height
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude'
    },
    height_6AHB9JfyQ2: {
        // Span / Power / Neutral Circuit / Midspan Height
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude'
    },
    height_m7IT9dM65d: {
        // Span / Power / Neutral Circuit / Bolt Height
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude'
    },
    height_LRsPGlovIK: {
        // Span / Power / Secondary Circuit / Bolt Height 1
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude'
    },
    height_3ExLy1PIFT: {
        // Span / Power / Secondary Circuit / Bolt Height 2
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude'
    },
    height_qzlYAwgWWz: {
        // Span / Power / Secondary Circuit / Bolt Height 3
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude'
    },
    height_yoiVBwCR0V: {
        // Span / Power / Secondary Circuit / Drip Loop Height
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude'
    },
    height_23ZhIdrLmU: {
        // Span / Power / Shield Wire / Height
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude'
    },
    spanCommunicationHeight: {
        // Span / Communication / Height
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude'
    },
    spanGuyHeight: {
        // Span / SpanGuy / Height
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude'
    },
    height_ZiyDtZPUu5: {
        // Span / SpanGuy / Midspan Height
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude'
    }
};
const transformDDSHeight = {
    // @TODO: replace with [DDSField.JOINT_USE_CABLE_ATTACHMENT_HEIGHT] once core-model-pole is merged into core shared
    ddsJointUseCableAttachmentHeight: {
        // Span / Joint Use Cable / Attachment Height
        type: core_api_1.IkeFieldType.HEIGHT,
        transform: 'exclude'
    }
};
/** Span-Linking provider for new IKE-Calc forms */
exports.IkeCalcExistingSpanProvider = {
    type: 'existingspan',
    distance: 10,
    vector: 'spanLength',
    fields: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, transformSpanType), transformSpanLength), transformWireSag), transformIkeCalcHeights), transformDDSHeight)
};
/** Span-Linking provider for old IKE-Calc and PoleForman forms */
exports.IkeCalcExistingSpanLegacyProvider = {
    type: 'existingspan',
    distance: 10,
    vector: 'spanLength',
    fields: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, transformSpanType), transformSpanLength), transformWireSag), transformIkeCalcHeights), transformPoleForemanHeights)
};
//# sourceMappingURL=form.subform.provider.js.map